'use client'
import { HotelData } from '@/types/Misc'
import dynamic from 'next/dynamic'
import { ReactElement, useEffect, useState } from 'react'
import LoadingIndicator from '@/components/elements/LoadingIndicator'

export default function MapLoader(props: {
  center: [number, number]
  HotelData: HotelData
}): ReactElement {
  const [loadMap, setLoadMap] = useState(false)

  useEffect(() => {
    setLoadMap(true)
  }, [])

  const Map = dynamic(() => import('@/components/hotel/hotel-map/MapDynamic'), {
    loading: () => (
      <LoadingIndicator additionalClassName="z-10 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
    ),
    ssr: false,
  })

  return (
    <div className="relative h-[300px] sm:h-[400px] xl:mx-0">
      {loadMap && <Map center={props.center} HotelData={props.HotelData} />}
    </div>
  )
}
